<template>
  <div class="carousel-container" @mouseenter="pause" @mouseleave="resume">
    <div style="position: relative;width: 100%;">
      <div
        class="carousel-wrapper"
        :class="{ paused: isPaused }"
        :style="{
          width: totalWidth + 'px',
          animationDuration: animationDuration + 's'
        }"
      >
        <!-- 原始 items -->
        <div
          v-for="(item, index) in items"
          :key="'orig-' + index"
          class="carousel-item"
        >
          <img :src="item.img" :alt="item.title" class="carousel-img" />
        </div>

        <!-- 无缝复制一份（关键！） -->
        <div
          v-for="(item, index) in items"
          :key="'copy-' + index"
          class="carousel-item"
        >
          <img :src="item.img" :alt="item.title" class="carousel-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SmoothScrollCarousel",
  props: {
    items: {
      type: Array,
      required: true
    },
    // 滚动一圈所需时间（秒）
    duration: {
      type: Number,
      default: 20
    },
    itemWidth: {
      type: Number,
      default: 225
    },
    gap: {
      type: Number,
      default: 15 // 间距
    }
  },
  data() {
    return {
      isPaused: false
    };
  },
  computed: {
    // 单份 items 的总宽度（含 margin）
    singleWidth() {
      return this.items.length * (this.itemWidth + this.gap) - this.gap;
    },
    // 总宽度 = 两份
    totalWidth() {
      return this.singleWidth * 2;
    },
    // CSS 动画持续时间
    animationDuration() {
      return this.duration;
    }
  },
  methods: {
    pause() {
      this.isPaused = true;
    },
    resume() {
      this.isPaused = false;
    }
  }
};
</script>

<style scoped>
.carousel-container {
  width: 100%;
  /* max-width: 1200px; */
  overflow-x: hidden;
  padding: 0 10px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #fafcff 0%, #ffecc4 100%);
}

.carousel-wrapper {
  display: flex;
  height: 360px;
  padding: 30px 0;
  box-sizing: border-box;
  animation: scroll linear infinite;
  z-index: 99;
}

.carousel-wrapper.paused {
  animation-play-state: paused;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.carousel-item {
  width: 225px;
  height: 306px;
  flex-shrink: 0;
  margin-right: 15px;
  border-radius: 12px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: scale(1);
  flex-wrap: wrap;
  color: #7c8294;
}

.carousel-item:hover {
  transform: scale(1.05);
  box-shadow: 0px 0px 14px 0px rgba(87, 87, 87, 0.5);
  z-index: 2;
  position: relative;
  color: #000;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.carousel-title {
  font-size: 18px;
  font-weight: bold;
  margin: 16px 0;
  color: #333;
}

.carousel-desc {
  font-size: 14px;

  line-height: 1.6;
  padding: 0 10px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper1.vue